import * as types from '../../mutation_types';
import { https } from './http';

const state = {
    data:{},
    page:'',
    currentpage:'',
    loading:false,
    search:'',
    company:'',
    supplier_from:'',
    supplier_to:'',
    date_from:'',
    date_to:'',
    material:'',
    user:'',
    status:''
};
const getters = {
    data:state=>state.data,
    page:state=>state.page,
    currentpage:state=>state.currentpage,
    loading:state=>state.loading,
    search:state=>state.search,
    company:state=>state.company,
    supplier_from:state=>state.supplier_from,
    supplier_to:state=>state.supplier_to,
    date_from:state=>state.date_from,
    date_to:state=>state.date_to,
    material:state=>state.material,
    user:state=>state.material,
    status:state=>state.status
};
const actions = {
    async fetchApprovedPurchaseReturns({commit}){
        commit(types.APP_PURCHASE_RETURN_LOADING);
        let uri = `/temporary-po-header?page=${state.page}&currentpage=${state.currentpage}&type=RETD&date_from=${state.date_from}&date_to=${state.date_to}&vendor_from=${state.supplier_from}
            &vendor_to=${state.supplier_to}&company=${state.company}&status=${state.status}&user=${state.user}&po_number=${state.search}&matnr=${state.material}`
        await https().get(uri).then(response=>{
            commit(types.APP_PURCHASE_RETURN_DATA,response.data);
            commit(types.APP_PURCHASE_RETURN_LOADING);
        }).catch(error=>{
            console.log(error);
            commit(types.APP_PURCHASE_RETURN_LOADING);
        })
    }
};
const mutations = {
    [types.APP_PURCHASE_RETURN_DATA](state,data){
        state.data = data;
    },
    [types.APP_PURCHASE_RETURN_PAGE](state,data){
        state.page = data;
    },
    [types.APP_PURCHASE_RETURN_CURRENTPAGE](state,data){
        state.currentpage = data;
    },
    [types.APP_PURCHASE_RETURN_LOADING](state){
        state.loading = !state.loading;
    },
    [types.APP_PURCHASE_RETURN_SEARCH](state,data){
        state.search = data;
    },
    [types.APP_PURCHASE_RETURN_COMPANY](state,data){
        state.compay = data;
    },
    [types.APP_PURCHASE_RETURN_SUPPLIER_FROM](state,data){
        state.supplier_from = data;
    },
    [types.APP_PURCHASE_RETURN_SUPPLIER_TO](state,data){
        state.supplier_to = data;
    },
    [types.APP_PURCHASE_RETURN_DATE_FROM](state,data){
        state.date_from = data;
    },
    [types.APP_PURCHASE_RETURN_DATE_TO](state,data){
        state.date_to = data;
    },
    [types.APP_PURCHASE_RETURN_MATERIAL](state,data){
        state.material = data;
    },
    [types.APP_PURCHASE_RETURN_USER](state,data){
        state.user = data;
    },
    [types.APP_PURCHASE_RETURN_STATUS](state,data){
        state.status = data;
    }
};
export {
    state,getters,actions,mutations
}